export default __webpack_public_path__ + "static/media/foto4.f79aba2c.jpg";